import { createBaseApi, getAuthHeaders } from '../utils/baseApi';

const apiVersion = 'v1';

const { getJson, postJson, deleteJson, putJson } = createBaseApi(`/api/${apiVersion}`, { headers: getAuthHeaders });

export const getRecord = id => getJson(`/records/${id}`);

export const updateInsuranceRequirement = (id, data) => putJson(`/records/${id}`, data);

export const archiveRecord = id => putJson(`/records/${id}/archive`);

export const reactivateRecord = id => putJson(`/records/${id}/reactivate`);

export const deleteRecord = id => deleteJson(`/records/${id}`);

export const getRecordPolicies = (id, filter) => getJson(`/records/${id}/policies`, { filter });

// temporary route till we refactor backend
export const getRecordDocuments = (id, filter) => getJson(`/records/${id}/documents`, { filter });

export const getRecordPolicyRequirements = id => getJson(`/records/${id}/policy-requirements`);

export const getRecordItemRequirements = id => getJson(`/records/${id}/item-requirements`);

export const getRecordDocumentRequirements = id => getJson(`/records/${id}/document-requirements`);

export const getRecordLanguageRequirements = id => getJson(`/records/${id}/language-requirements`);

export const getRecordQuestionRequirements = id => getJson(`/records/${id}/question-requirements`);

export const updateRequirementStatuses = ({
  recordId,
  policyId,
  policyTypeId,
  documentTypeId,
  status,
  logActivity = true
}) => putJson(`/records/${recordId}/requirements`, {
  insurance_policy_id: policyId,
  insurance_policy_type_id: policyTypeId,
  insurance_document_type_id: documentTypeId,
  log_activity: logActivity,
  status
});

export const transferRecordProject = (recordId, jobId) => putJson(`/records/${recordId}/jobs/${jobId}`);

export const createRecordAttachment = (recordId, data) => postJson(`/records/${recordId}/attachments`, data);

export const listRecordAttachments = recordId => getJson(`/records/${recordId}/attachments`);

export const listRecordWatchers = recordId => getJson(`/records/${recordId}/watchers`);

export const createRecordWatcher = (recordId, userIds) => postJson(`/records/${recordId}/watchers`, { user_ids: userIds });

export const deleteRecordWatcher = (recordId, userIds) => deleteJson(`/records/${recordId}/watchers`, { user_ids: userIds });

export const listRecordGptRequests = (recordId, pageData) => getJson(`/records/${recordId}/gpt-requests`, pageData);

export const getRecordGptRequest = (recordId, gptRequestId) => getJson(`/records/${recordId}/gpt-requests/${gptRequestId}`);

export const getAgentRemovalPreview = (recordId, agentUserId) => getJson(`/records/${recordId}/agents/${agentUserId}/removal-preview`);

export const removeRecordAgent = (recordId, agentUserId) => deleteJson(`/records/${recordId}/agents/${agentUserId}`);

export const createRecordCloneBatch = (recordId, {
  recordIds,
  policyIds = [],
  documentIds = [],
  copyRequirementStatuses = false
}) => postJson(`/records/${recordId}/clone-batches`, {
  record_ids: recordIds,
  policy_ids: policyIds,
  document_ids: documentIds,
  copy_requirement_statuses: copyRequirementStatuses
});

export const getRecordCloneBatch = batchId => getJson(`/record-clone-batches/${batchId}`);
